import React, { FC, SVGProps } from 'react';
interface ArrowTurnRightSolidFullProps extends SVGProps<any> {
  color: string;
}

const ArrowTurnRight: FC<ArrowTurnRightSolidFullProps> = ({ color, ...props }) => (
  <svg viewBox="0 0 640 640" {...props}>
    <path
      fill={color}
      d="M128 480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-53 43-96 96-96h306.7l-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l73.4-73.3H160c-17.7 0-32 14.3-32 32v96z"
    />
  </svg>
);

export default ArrowTurnRight;
